/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { GuideProgram } from 'client-code/filtered-guide';

import { InteractiveComponents } from '../../../core/enums';
import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { TOfferPreview } from '../../../core/types';
import {
    ON_FILTERED_GUIDE_API_ERROR,
    ON_REPAINT_FILTERED_GUIDE,
    ON_SET_CARET_VISIBILITY_FILTERED_GUIDE,
    ON_SET_FILTERED_GUIDE_SELECTED_ROW,
    ON_SET_FILTERED_GUIDE_SELECTED_ROW_PREVIEW,
    ON_SET_FILTERED_GUIDE_TURBO_SCROLL,
    ON_SET_GHOST_MODE_FILTERED_GUIDE,
    ON_SET_NULL_REFETCH_TIMESTAMP,
    ON_UPDATE_LAST_REFETCH_TIMESTAMP,
} from './filteredguide.types';

export const onSetFilteredGuideSelectedRowAction = (
    selectedProgram: GuideProgram | null,
): TivoPayloadAction<{ selectedProgram: GuideProgram | null }> => ({
    type: ON_SET_FILTERED_GUIDE_SELECTED_ROW,
    payload: {
        selectedProgram,
    },
});

export const onSetFilteredGuideSelectedRowPreviewAction = (
    selectedProgramPreviewPromise: Promise<TOfferPreview> | null,
): TivoPayloadAction<{ selectedProgramPreviewPromise: Promise<TOfferPreview> | null }> => ({
    type: ON_SET_FILTERED_GUIDE_SELECTED_ROW_PREVIEW,
    payload: {
        selectedProgramPreviewPromise,
    },
});

export const onRepaintFilteredGuideAction = () => ({
    type: ON_REPAINT_FILTERED_GUIDE,
    payload: {},
});

export const onSetFilteredGuideTurboScrollAction = (
    value: boolean,
    direction: InteractiveComponents.NORTH | InteractiveComponents.SOUTH,
): TivoPayloadAction<{
    filteredGuideTurboScroll: boolean;
    filteredGuideTurboScrollDirection: InteractiveComponents.NORTH | InteractiveComponents.SOUTH;
}> => ({
    type: ON_SET_FILTERED_GUIDE_TURBO_SCROLL,
    payload: {
        filteredGuideTurboScroll: value,
        filteredGuideTurboScrollDirection: direction,
    },
});

export const setGhostModeAction = (
    ghostMode: boolean,
): TivoPayloadAction<{ ghostMode: boolean }> => ({
    type: ON_SET_GHOST_MODE_FILTERED_GUIDE,
    payload: {
        ghostMode,
    },
});

export const setCaretVisibilityAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{ isCaretVisible: boolean }> => ({
    type: ON_SET_CARET_VISIBILITY_FILTERED_GUIDE,
    payload: {
        isCaretVisible,
    },
});

export const updateFilteredGuideLastRefetchTimestampAction = () => ({
    type: ON_UPDATE_LAST_REFETCH_TIMESTAMP,
    payload: {},
});

export const resetToNullFilteredGuideLastRefetchTimestampAction = () => ({
    type: ON_SET_NULL_REFETCH_TIMESTAMP,
    payload: {},
});

export const setFilteredGuideApiErrorAction = (
    isError: boolean,
): TivoPayloadAction<{ isError: boolean }> => ({
    type: ON_FILTERED_GUIDE_API_ERROR,
    payload: {
        isError,
    },
});
